// extracted by mini-css-extract-plugin
export default {"accordionLayout":"Accordion_accordionLayout__3X1gm","accordionContent":"Accordion_accordionContent__XAOoM","accordionTrigger":"Accordion_accordionTrigger__DIpQQ"};